import { v4 as uuidV4 } from 'uuid'

class Audience {
  static generateId() {
    return uuidV4().replace(/-/g, '')
  }
}

export default Audience
